import { Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import ProjectForm from './pages/ProjectForm';
import Users from './pages/Users';
import UserForm from './pages/UserForm';
import Organizations from './pages/Organizations';
import OrgForm from './pages/OrgForm';
import Login from './pages/Login';
import { ProtectedRoute } from './features/auth/ProtectedRoute';

const adminRoles = ['admin', 'super_admin'] as const;
const superOnly = ['super_admin'] as const;

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />

      {/* projects */}
      <Route
        path="/projects"
        element={
          <ProtectedRoute>
            <Projects />
          </ProtectedRoute>
        }
      />
      <Route
        path="/projects/new"
        element={
          <ProtectedRoute requiredRoles={[...adminRoles]}>
            <ProjectForm mode="create" />
          </ProtectedRoute>
        }
      />
      <Route
        path="/projects/:id/edit"
        element={
          <ProtectedRoute requiredRoles={[...adminRoles]}>
            <ProjectForm mode="edit" />
          </ProtectedRoute>
        }
      />

      {/* users */}
      <Route
        path="/users"
        element={
          <ProtectedRoute requiredRoles={[...adminRoles]}>
            <Users />
          </ProtectedRoute>
        }
      />
      <Route
        path="/users/new"
        element={
          <ProtectedRoute requiredRoles={[...adminRoles]}>
            <UserForm mode="create" />
          </ProtectedRoute>
        }
      />
      <Route
        path="/users/:id/edit"
        element={
          <ProtectedRoute requiredRoles={[...adminRoles]}>
            <UserForm mode="edit" />
          </ProtectedRoute>
        }
      />

      {/* organizations */}
      <Route
        path="/organizations"
        element={
          <ProtectedRoute requiredRoles={[...superOnly]}>
            <Organizations />
          </ProtectedRoute>
        }
      />
      <Route
        path="/organizations/new"
        element={
          <ProtectedRoute requiredRoles={[...superOnly]}>
            <OrgForm mode="create" />
          </ProtectedRoute>
        }
      />
      <Route
        path="/organizations/:id/edit"
        element={
          <ProtectedRoute requiredRoles={[...superOnly]}>
            <OrgForm mode="edit" />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
